var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-item"
  }, [_c('div', {
    staticClass: "s-item-info"
  }, [_c('div', {
    staticClass: "s-space-y-2 s-mr-auto"
  }, [_c('p', {
    staticClass: "s-text-gray-darker s-font-semibold"
  }, [_vm._v("發票號碼：" + _vm._s(_vm.invoiceLog.no))]), _c('p', {
    staticClass: "s-text-gray s-text-xs s-whitespace-nowrap"
  }, [_vm._v("開立日期：" + _vm._s(_vm.moment(_vm.invoiceLog.issued_at).format('YYYY-MM-DD')))]), _c('p', {
    staticClass: "s-text-gray s-text-xs s-whitespace-nowrap"
  }, [_vm._v("登錄時間：" + _vm._s(_vm.moment(_vm.invoiceLog.created_at).format('YYYY-MM-DD hh:mm:ss')))])]), _c('div', {
    staticClass: "s-flex s-flex-col s-items-end"
  }, [_c('span', {
    staticClass: "s-tag my-1"
  }, [_vm._v(_vm._s(_vm.statusMapping[_vm.invoiceLog.status]))]), _c('span', {
    staticClass: "s-tag my-1 s-tag-outline"
  }, [_vm._v(_vm._s(_vm.typeMapping(_vm.invoiceLog)))])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }